// Authorization durations are decimal hours in the model and whole minutes on the API.
// Unlike a time of day, a duration can exceed 24 (or 99) hours.
export function authorizationDurationInput() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, model) {
            const minutesMode = () => scope.$eval(attrs.durationMinutesMode);
            const empty = value => value === null || value === undefined || value === '';

            model.$formatters.push(value => {
                if (empty(value)) return '';
                if (!minutesMode()) return String(Number(Number(value).toFixed(3)));
                const minutes = Math.round(Number(value) * 60);
                return `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
            });

            model.$parsers.push(value => {
                if (empty(value)) return null;
                if (!minutesMode()) {
                    return /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value) ? Number(value) : undefined;
                }

                // Insert the separator while typing or pasting compact digits.
                // Extra digits extend the hours, so totals such as 100:59 work too.
                let masked = value;
                if (/^\d{2,}$/.test(value) || /^\d+:\d{3,}$/.test(value)) {
                    const digits = value.replace(':', '');
                    const separator = digits.length <= 3 ? 2 : digits.length - 2;
                    masked = `${digits.slice(0, separator)}:${digits.slice(separator)}`;
                }
                if (masked !== value) {
                    model.$setViewValue(masked);
                    model.$render();
                }
                const match = /^(\d+):([0-5]\d)$/.exec(masked);
                if (!match) return undefined;
                const minutes = Number(match[1]) * 60 + Number(match[2]);
                return Number.isSafeInteger(minutes) ? minutes / 60 : undefined;
            });

            model.$validators.duration = value => empty(value) || (Number.isFinite(value) && value >= 0);
            model.$validators.maxDuration = value => empty(value) || !attrs.maxDurationHours || value <= Number(attrs.maxDurationHours);
            const unwatch = scope.$watch(attrs.durationMinutesMode, () => model.$processModelValue());
            const blur = () => scope.$evalAsync(() => {
                if (model.$valid) model.$processModelValue();
            });
            element.on('blur', blur);
            scope.$on('$destroy', () => {
                unwatch();
                element.off('blur', blur);
            });
        }
    };
}
